<div class="card w-100 mb-2">
  <div class="row">
    <div class="col-md-12">
      <div class="card-body p-4">
        <h3 *ngIf="task.isCompleted()" class="fw-bold mb-3 pb-2 fs-4 text-success"><i
            class="bi bi-check2-circle fw-bold me-2"></i> Task Created Successfully!</h3>
        <h3 *ngIf="task.isPending()" class="fw-bold mb-3 pb-2 fs-4 text-gray-600"><i
            class="bi bi-check2-circle fw-bold me-2"></i> Task Execution in Progress!</h3>
        <h3 *ngIf="task.isfailed()" class="fw-bold mb-3 pb-2 fs-4 text-danger"><i
            class="bi bi-check2-circle fw-bold me-2"></i> Task Execution Failed!</h3>
        <hr>
        <div class="row mb-1">
          <label class="col-lg-4 col-form-label fw-semibold fs-8">Task Description</label>
          <div class="col-lg-8">
            <div class="form-control form-control-lg form-control-solid">{{ task.message }}</div>
          </div>
        </div>
        <div class="row mb-1">
          <label class="col-lg-4 col-form-label fw-semibold fs-8">Task Scope
          </label>
          <div class="col-lg-8">
            <div class="form-control form-control-lg form-control-solid">{{ task.scope }}</div>
          </div>
        </div>
        <div class="row mb-1">
          <label class="col-lg-4 col-form-label fw-semibold fs-8">Task Type
          </label>
          <div class="col-lg-8">
            <div class="form-control form-control-lg form-control-solid">{{ task.type }}</div>
          </div>
        </div>
        <div class="row mb-1">
          <label class="col-lg-4 col-form-label fw-semibold fs-8">Task Status
          </label>
          <div class="col-lg-8">
            <div class="form-control form-control-lg form-control-solid">
              <span [innerHTML]="task.status | statusBadge"></span>
            </div>
          </div>
        </div>
        <div class="row mb-1">
          <label class="col-lg-4 col-form-label fw-semibold fs-8">Date Created:</label>
          <div class="col-lg-8">
            <input class="form-control form-control-lg form-control-solid"
              value="{{ task.date_created | date : 'd MMM, yyyy HH:mm:ss' }}"
              disabled />
          </div>
        </div>
        <div *ngIf="task.isCompleted()" class="row mb-1">
          <hr>
          <div class="col-lg-12">
            <a (click)="goToRoute()" class="btn btn-lg btn-primary text-white fw-bold d-flex justify-content-center">
              <i class="bi bi-box-arrow-up-right fw-bold me-2"></i>Go to Systems Tasks Index</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
